enum GraphEndpoint {
  SANDBOX = 'https://federation-gateway.dev1.sandbox-ezcater.com',
  RAINFORESTQA = 'https://federation-gateway.rainforestqa.sandbox-ezcater.com',
  STAGING = 'https://federation-gateway.staging-ezcater.com',
  PRODUCTION = 'https://federation-gateway.ezcater.com',
  LOCALHOST = 'http://localhost:21216',
}

export default GraphEndpoint;
